import { type DistanceUnit, distanceUnits } from "@/models/siteUnit.types";
import { createDistanceUnitPort } from "@/models/units/distanceUnitPort";

/** 転圧外周列 1 層分。`outline` は flat [x,y,z,...] の閉列 (m) */
interface ICompactionOutlineLayer {
	outline: ReadonlyArray<number>;
}

const EOL = "\r\n";

function fmt(v: number): string {
	return Number.isFinite(v) ? v.toFixed(3) : "0.000";
}

/**
 * 転圧 CSV を組み立てる。`layer N,,` ヘッダ行に続けて外周列の点を x,y で順に書く
 * (z は出力しない。層内に区切り行は入れない。穴・飛び地は橋渡し済みの 1 本の閉列)。
 * 層の並び (= N) は呼び出し側の順序に従う。座標は現場距離単位へ換算する。
 */
export function buildCompactionCsvString(
	layers: ReadonlyArray<ICompactionOutlineLayer>,
	distanceUnit: DistanceUnit = distanceUnits.METERS,
): string {
	// Distance conversion is a pure factor, so the display value of 1 m is the factor.
	const scale = createDistanceUnitPort(distanceUnit).toDisplay(1);
	const lines: string[] = [];
	for (let layerIdx = 0; layerIdx < layers.length; layerIdx++) {
		const layerNum = layerIdx + 1;
		lines.push(`layer ${layerNum},,`);
		const points = layers[layerIdx].outline;
		for (let i = 0; i + 2 < points.length; i += 3) {
			lines.push(`,${fmt(points[i] * scale)},${fmt(points[i + 1] * scale)}`);
		}
	}
	return lines.join(EOL) + EOL;
}
